import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import {
  QA_NAME_SHOW_LESS_BUTTON,
  QA_NAME_SHOW_MORE_BUTTON,
} from '../../../constants/qa'
import { useReadMore, useThemeMode } from '../../../hooks'
import { openHtmlLinksInNewTab } from '../../../utils/html'
import { getThemeContentHtml } from '../../../utils/themeContent'
import Button, { BUTTON_HEIGHT_24 } from '../../Button'

import * as styles from './NewsboardMessageText.module.css'

function NewsboardMessageText({ messageContent, unread }) {
  const { t } = useTranslation()

  const { theme } = useThemeMode()

  const { handleClickReadMore, isReadMore, showReadMore, textRef } =
    useReadMore({ textData: messageContent })

  const messageClassName = classNames(styles.message, {
    [styles.unread]: unread,
  })

  return (
    <>
      <div
        className={messageClassName}
        dangerouslySetInnerHTML={{
          __html: getThemeContentHtml(
            openHtmlLinksInNewTab(messageContent),
            theme
          ),
        }}
        ref={textRef}
      />
      {showReadMore ? (
        <Button.Contained
          isGrey
          className={styles.readMoreButton}
          height={BUTTON_HEIGHT_24}
          qaName={
            isReadMore ? QA_NAME_SHOW_LESS_BUTTON : QA_NAME_SHOW_MORE_BUTTON
          }
          text={t(
            isReadMore ? 'Newsboard.ReadLessBtnKey' : 'Newsboard.ReadMoreBtnKey'
          )}
          onClick={handleClickReadMore}
        />
      ) : null}
    </>
  )
}

export default NewsboardMessageText
